import { SettingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { paths } from '@app/constants';
import { Button, useTheme } from '@ui';

export const ServerErrorPage = () => {
  const { t } = useTranslation();
  const { bgColor } = useTheme();

  const handleRefresh = () => window.location.reload();

  return (
    <div
      className="flex min-h-safe-screen items-center justify-center h-screen"
      style={{ backgroundColor: bgColor }}
    >
      <div className="max-w-2xl text-center text-white">
        <div className="flex gap-4">
          <SettingOutlined className="text-[200px]" />
          <div className="flex flex-col gap-4 items-start">
            <h1 className="mb-1 font-sans text-3xl">
              {t('server_error_page.internal_server_error')}
            </h1>
            <p className="my-1 font-sans text-xl text-start">{t('server_error_page.text')}</p>
            <div className="flex gap-4">
              <Button
                onClick={handleRefresh}
                ghost
                className="hover:border-base-100 hover:text-base-100"
              >
                {t('common.refresh')}
              </Button>
              <Button
                href={`/${paths.app}`}
                ghost
                className="hover:border-base-100 hover:text-base-100"
              >
                {t('common.back_home')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
